import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import circle from '../../../../images/main/curcle.svg'
import search from '../../../../images/main/search.svg'
// import banner from '../../../../images/main/hh.jpg'

import styles from './styles.module.scss'

const SearchJob = ({ filterVacation, setSearchMainInput, searchMainInput }) => {
  const [enter, setEnter] = useState('')
  useEffect(() => {
    if (enter === 'Enter') {
      document.getElementById('myBtn').click()
    }
  }, [enter])

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSide_wrap}>
        <div className={styles.leftSide}>
          <p className={styles.title}>Актуальные вакансии</p>
          {filterVacation
            ?.filter((vacation, index) => index < 3)
            .map((item, index) => (
              <div className={styles.list} key={index}>
                <p className={styles.text_desc}>{item.city.name}</p>
                <Link
                  to={'/listing/jobs' + `/id=${item.id}`}
                  state={{ itemVacation: item, route: '/', pageId: '/listing/jobs' + `/id=${item.id}` }}
                >
                  <p className={styles.text}>{item.positionName}</p>
                </Link>
                <svg width='8' height='8.5' viewBox='0 0 8 9' xmlns={circle} className={styles.circle}>
                  <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                </svg>
              </div>
            ))}
          <Link to='/listing' className={styles.button}>
            Все вакансии <span>&rarr;</span>
          </Link>
        </div>
        {/* <a className={styles.left_banner} href="https://rating.hh.ru/poll" target="_blank">
          <img src={banner} alt=""/>
        </a> */}
      </div>

      <div className={styles.rightSide}>
        <div className={styles.rightSide_wrap}>
          <p className={styles.text}>Карьера под вашим контролем</p>
          <p className={styles.subtext}>Стройте свою карьеру вместе с Generium.</p>
          <Link to='/listing' className={styles.button}>
            Все вакансии <span>&rarr;</span>
          </Link>
          <div className={styles.form}>
            <input
              onKeyDown={e => setEnter(e.key)}
              className={styles.input}
              placeholder='Найти вакансию'
              value={searchMainInput}
              onChange={e => setSearchMainInput(e.target.value)}
            />
            <Link to='/listing' id='myBtn'>
              <img src={search} alt='search' className={styles.search} draggable='false' />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchJob
